import commonMapping from "@/mapping/common";

const tun_proto_list = [
  { id: "tun_vpn_type_udp", value: "udp", config: "udp", label: "UDP" },
  { id: "tun_vpn_type_tcp", value: "tcp", config: "tcp", label: "TCP" },
];

const tap_proto_list = [
  { id: "vpn_type_udp", value: "udp", config: "udp", label: "UDP" },
  { id: "vpn_type_tcp", value: "tcp", config: "tcp", label: "TCP" },
];

const access_mode_list = [
  { id: "vpn_access_home", value: "auto", config: "auto", label: "auto" },
  { id: "vpn_access_auto", value: "all", config: "all", label: "inter_home_network" },
  { id: "vpn_access_all", value: "onlylan", config: "home", label: "home_network" },
];

export const vpnService = {
  vpnservice_enable: commonMapping.intToBoolean,
  tun_proto: tun_proto_list,
  tap_proto: tap_proto_list,
  access_mode: access_mode_list,
};

export default vpnService;
